import { LegalEntityAddressInfo } from "./legal-entity-address-info";

export class LegalEntityInfo {

    id: number | undefined;
    roles: EnumLegalEntityRole[] | undefined;
    statusId: number | undefined;
    companyName: string | undefined;
    brandName: string | undefined;
    legalFormId: number | undefined;
    fiscalCode: string | undefined;
    vatNumber: string | undefined;
    // legalEntityAddressInfo: LegalEntityAddressInfo | undefined;
}

export enum EnumLegalEntityRole {
    NONE = "NONE",
    CUSTOMER = "CUSTOMER",
    WINE_SALOON = "WINE_SALOON",
    WINE_CELLAR = "WINE_CELLAR",
    WINE_COOPERATIVE = "WINE_COOPERATIVE",
    WEBSITE_MANAGER = "WEBSITE_MANAGER",
    ANY = "ANY"
}
